var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6647 3.91935C13.0775 4.28627 13.1147 4.91834 12.7478 5.33112L7.66812 11.0457C7.13133 11.6496 6.18506 11.6411 5.65923 11.0276L3.90775 8.98422C3.54833 8.56489 3.59689 7.93359 4.01622 7.57417C4.43554 7.21475 5.06684 7.26331 5.42627 7.68263L6.68071 9.14615L11.2529 4.00239C11.6199 3.58961 12.2519 3.55243 12.6647 3.91935Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckType);
export default __webpack_public_path__ + "static/media/CheckType.27135094188db93b82311aef5c063f2e.svg";
export { ForwardRef as ReactComponent };